import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PMDashboard from './PMDashboard';
import PropertiesView from './PropertiesView';
import WorkOrdersView from './WorkOrdersView';
import TurnoversView from './TurnoversView';
import OwnersView from './OwnersView';
import ServiceWorkersView from './ServiceWorkersView';
import LeadsView from './LeadsView';

export default function PropertyView() {
  return (
    <Routes>
      <Route index element={<PMDashboard />} />
      <Route path="properties" element={<PropertiesView />} />
      <Route path="work-orders" element={<WorkOrdersView />} />
      <Route path="turnovers" element={<TurnoversView />} />
      <Route path="owners" element={<OwnersView />} />
      <Route path="service-workers" element={<ServiceWorkersView />} />
      <Route path="leads" element={<LeadsView />} />
      <Route path="*" element={<Navigate to="/property" replace />} />
    </Routes>
  );
}
